import React from "react";

export const InlineList = ({ children }) =>
  <ul className="list-inline ml-3">
    {children}
  </ul>;